@if (list && list.length > 0) {
    <p class="list-note">Click a model to zoom to it in the graph.</p>
    <ul class="models-list">
        @for (item of list; track item._key) {
            <li>
                <button type="button" (click)="selectModel(item._key)">
                    <span class="swatch" [style.background-color]="item.colour"></span>
                    <span class="model-name">{{item.name}}</span>
                    <mat-icon>zoom_in</mat-icon>
                </button>
            </li>
        }
    </ul>
}@else {
    <p class="list-note">No models are shown. Choose some with the model filter, or show all models.</p>
}
